<div class="common-wrapper">
    <div class="main-hd-txt">
        <span>
            <h4>COMPANY<span class="head-btn-style">
                    <button *ngIf="!listView" (click)="goToBackTab()" class="go-back-btn-head" title="Back Tab">
                        <i class="bi bi-arrow-left-circle"></i> Back</button></span><span class="head-btn-style">
                    <button *ngIf="!listView" id="txt_com_save" (click)="save($event,proofTypes)" class="save-btn-head"
                        [disabled]="saveDisabled" title="Save">
                        <i class="bi bi-file-earmark-plus"></i> Save</button></span></h4>
        </span>
    </div>
    <div *ngIf="listView" class="top-btns ps-3">
        <grid [entities]="companys" [actionExclude]="['feedback','column']" [checkboxCol]="true"
            [entityColumns]="companyColumns" [selectionField]="'Company_Id'" [addEntityIcon]="'bi bi-plus-square'"
            [addEntityCaption]="'Add'" [downloadEntityCaption]="'Download'" (downloadEntities)="onExcelExport()"
            (addEntity)="addCompany($event)" (editEntity)="editCompany($event)"
            (refreshEntities)="refreshCompany($event)" (deleteEntity)="deleteCompany($event)"
            (onPaginationChange)="onPaginationChange($event)" [serverPagination]="true" [pageSizes]="pageSizes"
            [pageSize]="defaultPageSize" [skip]="pageSkip" (onFilterChange)="onFilterChange($event)"></grid>

    </div>

    <div *ngIf="!listView">
        <div class="row sub-head">
            <div class="col-md-7 text-bold">
                {{ formCaption }}
            </div>
            <div class="col-md-5 text-end">
                <button (click)="clearCompany()" class="btn-3 bt-3-ic"><span>Clear</span></button>
                <button (click)="revertChanges()" class="btn-3 bt-4-ic"><span>Revert Changes</span></button>
                <button (click)="gotoBack()" class="btn-3 bt-4-ic"><span>Go Back</span></button>
            </div>
        </div>

        <div class="col-md-12 content-area">
            <div class="row">
                <div class="col-md-4 mt-m1">
                    <textbox [caption]="'Company Name'" [mandatory]="true" [maxlength]="100" [formData]="entity"
                        [fieldName]="'CompanyName'" id="txt_com_CompanyName" [(ngModel)]="entity.CompanyName"
                        ngDefaultControl></textbox>
                </div>
                <div class="col-md-4 mt-m1">
                    <textbox [caption]="'Email id'" [mandatory]="true" [formData]="entity" [maxlength]="100"
                        id="txt_com_Email" [fieldName]="'EmailId'" [(ngModel)]="entity.EmailId" ngDefaultControl>
                    </textbox>
                </div>
                <div class="col-md-4 mt-m1">
                    <textbox [caption]="'Phone'" [mandatory]="true" [maxlength]="10" [formData]="entity"
                        [fieldName]="'Phone'" id="txt_com_phone" (paste)="onPaste($event)"
                        (keypress)="numberOnly($event)" [(ngModel)]="entity.Phone" ngDefaultControl></textbox>
                </div>
            </div>


            <div class="row" *ngFor="let type of proofTypes">
                <div class="col-md-4 mt-m1"
                    *ngIf="(type.proofType==='CIN')||(type.proofType==='PAN')||(type.proofType==='TAN')">
                    <textbox [caption]="type.displayName" [mandatory]="type.IsMandatory"
                        [placeholder]="type.description" [maxlength]="type.maxlength" [(ngModel)]="type.value"
                        ngDefaultControl>
                    </textbox>
                    <!-- <span class="alert" *ngIf="Isvalidation">{{type.validationMessage}}</span> -->
                </div>
                <div class="col-md-4 mt-m1" *ngIf="(type.proofType==='address')">
                    <!-- <textarea  [placeholder]="type.description"
                         [maxlength]="type.maxlength" [(ngModel)]="type.value"  ngDefaultControl>
                    </textarea> -->
                    <textbox [caption]="type.displayName" [mandatory]="type.IsMandatory"
                        [placeholder]="type.description" [maxlength]="type.maxlength" [multiline]="true"
                        [(ngModel)]="type.value" ngDefaultControl>
                    </textbox>
                </div>
                <!-- </div> -->

                <!-- <div class="alert" *ngIf="type.Isvalidation">
                   
                   </div>  
                 -->
                <div class="col-md-4 mt-m3"
                    *ngIf="(type.proofType==='MOA')||(type.proofType==='AOA')||(type.proofType==='COI')||(type.proofType==='RBI')||(type.proofType==='OtherEnclosure')">
                    <label for="displayName" class="label label-1 thicker">{{type.Label}}</label>
                </div>
                <div class="col-md-8 mt-m2">
                    <input id="file-input" type="file" (change)="fileChanged($event,type);" accept=".pdf,.doc"  />
                    <a *ngIf="type.proofType==='address'" id= "link" download>{{download}}</a>
                    <a *ngIf="type.proofType==='CIN'" id= "CINlink" download>{{CINdownload}}</a>
                    <a *ngIf="type.proofType==='PAN'" id= "PANlink" download>{{PANdownload}}</a>
                    <a *ngIf="type.proofType==='TAN'" id= "TANlink" download>{{TANdownload}}</a>
                    <a *ngIf="type.proofType==='AOA'" id= "AOAlink" download>{{AOAdownload}}</a>
                    <a *ngIf="type.proofType==='MOA'" id= "MOAlink" download>{{MOAdownload}}</a>
                    <a *ngIf="type.proofType==='COI'" id= "COIlink" download>{{COIdownload}}</a>
                    <a *ngIf="type.proofType==='RBI'" id= "RBIlink" download>{{RBIdownload}}</a>
                    <a *ngIf="type.proofType==='OtherEnclosure'" id= "Otherlink" download>{{Otherdownload}}</a>
                    <input type="button"  id="downloadbutton"  *ngIf="this.isDownloadButtonVisible"
                            (click)="downloadFunction(type)" value="Download" downloadLink/>
                    <span>
                        <!-- <img [src]="type.url" height="70" class="imgClass"> -->
                        <input type="button" id="removeImage1" class="close" *ngIf="type.button"
                            (click)="removeImage($event,type);" value="x" />
                    </span>
                </div>
                <!-- <div class="col-md-3 ">
                    <span (click)="savedocuments($event,'address');"><i class="bi bi-upload"></i>Upload</span> 
                </div> -->
            </div>
            <!-- <div class="row">
                <div class="col-md-4 mb-2">
                    <textbox [caption]="'CIN'" [mandatory]="true" [formData]="entity" [maxlength]="500"
                        [fieldName]="'CompanyAddress'" [(ngModel)]="entity.CIN" ngDefaultControl>
                    </textbox>
                </div>
                <div class="col-md-4 mb-2">
                    <input id="file-input" type="file" (change)="fileChanged($event,'CIN');" />
                    <span>
                        <img [src]="CINurl" height="70" class="imgClass">
                        <input type="button" id="removeImage2" class="close" *ngIf="CINisButtonVisible"
                            (click)="removeImage($event,'CIN');" value="x" />
                    </span>
                </div>
                <div class="col-md-3 ">

                    <a (click)="savedocuments($event,'CIN');"><i class="bi bi-upload"></i>Upload</a>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4 mb-2">
                    <textbox [caption]="'PAN'" [mandatory]="true" [formData]="entity" [maxlength]="10"
                        [fieldName]="'PAN'" [(ngModel)]="entity.PAN" ngDefaultControl>
                    </textbox>
                </div>
                <div class="col-md-4 mb-2">
                    <input id="file-input" type="file" (change)="fileChanged($event,'PAN');" />
                    <span>
                        <img [src]="PANurl" height="70" class="imgClass">
                        <input type="button" id="removeImage1" class="close" *ngIf="PANisButtonVisible"
                            (click)="removeImage($event,'PAN');" value="x" />
                    </span>
                </div>
                <div class="col-md-3 ">
                    <a (ngSubmit)="savedocuments($event,'PAN');"><i class="bi bi-upload"></i>Upload</a>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4 mb-2">
                    <textbox [caption]="'TAN'" [mandatory]="true" [formData]="entity" [maxlength]="10"
                        [fieldName]="'TAN'" [(ngModel)]="entity.TAN" ngDefaultControl>
                    </textbox>
                </div>
                <div class="col-md-4 mb-2">
                    <input id="file-input" type="file" (change)="fileChanged($event,'TAN');" />
                    <span>
                        <img [src]="TANurl" height="70" class="imgClass">
                        <input type="button" id="removeImage1" class="close" *ngIf="TANisButtonVisible"
                            (click)="removeImage($event,'TAN');" value="x" />
                    </span>
                </div>
                <div class="col-md-3 ">
                    <a (click)="savedocuments($event,'TAN');"><i class="bi bi-upload"></i>Upload</a>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4 mb-2">
                    <textbox [caption]="'MOA'" [mandatory]="true" [formData]="entity" [maxlength]="10"
                        [fieldName]="'MOA'" [(ngModel)]="entity.MOA" ngDefaultControl>
                    </textbox>
                </div>
                <div class="col-md-4 mb-2">
                    <input id="file-input" type="file" (change)="fileChanged($event,'MOA');" />
                    <span>
                        <img [src]="MOAurl" height="70" class="imgClass">
                        <input type="button" id="removeImage1" class="close" *ngIf="MOAisButtonVisible"
                            (click)="removeImage($event,'MOA');" value="x" />
                    </span>
                </div>
                <div class="col-md-3 ">
                    <span (click)="savedocuments($event,'MOA');"><i class="bi bi-upload"></i>Upload</span>
                </div>
            </div>

            <div class="row">
                <div class="col-md-4 mb-2">
                    <textbox [caption]="'AOA'" [mandatory]="true" [formData]="entity" [maxlength]="10"
                        [fieldName]="'AOA'" [(ngModel)]="entity.AOA" ngDefaultControl>
                    </textbox>
                </div>
                <div class="col-md-4 mb-2">
                    <input id="file-input" type="file" (change)="fileChanged($event,'AOA');" />
                    <span>
                        <img [src]="AOAurl" height="70" class="imgClass">
                        <input type="button" id="removeImage1" class="close" *ngIf="AOAisButtonVisible"
                            (click)="removeImage($event,'AOA');" value="x" />
                    </span>
                </div>
                <div class="col-md-3 ">
                    <a (click)="savedocuments($event,'AOA');"><i class="bi bi-upload"></i>Upload</a>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4 mb-2">
                    <textbox [caption]="'COI'" [mandatory]="true" [formData]="entity" [maxlength]="10"
                        [fieldName]="'COI'" [(ngModel)]="entity.COI" ngDefaultControl>
                    </textbox>
                </div>
                <div class="col-md-4 mb-2">
                    <input id="file-input" type="file" (change)="fileChanged($event,'COI');" />
                    <span>
                        <img [src]="COIurl" height="70" class="imgClass">
                        <input type="button" id="removeImage1" class="close" *ngIf="COIisButtonVisible"
                            (click)="removeImage($event,'COI');" value="x" />
                    </span>
                </div>
                <div class="col-md-3 ">
                    <a (click)="savedocuments($event,'COI');"><i class="bi bi-upload"></i>Upload</a>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4 mb-2">
                    <textbox [caption]="'RBI License'" [mandatory]="true" [formData]="entity" [maxlength]="20"
                        [fieldName]="'RBI_License'" [(ngModel)]="entity.RBI_License" ngDefaultControl>
                    </textbox>
                </div>
                <div class="col-md-4 mb-2">
                    <input id="file-input" type="file" (change)="fileChanged($event,'RBI');" />
                    <span>
                        <img [src]="RBIurl" height="70" class="imgClass">
                        <input type="button" id="removeImage1" class="close" *ngIf="RBIisButtonVisible"
                            (click)="removeImage($event,'RBI');" value="x" />
                    </span>
                </div>
                <div class="col-md-3 ">
                    <a (click)="savedocuments($event,'RBI');"><i class="bi bi-upload"></i>Upload</a>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4">
                    <checkbox id="chk_com_active" [caption]="' Active'" [(ngModel)]="entity.IsActive"></checkbox>
                </div>
            </div> -->
            <!--<div class="row">
                <div class="col-md-4 mb-2">
                    <btn [label]="'Save'" id="txt_com_save" (click)="save($event,proofTypes)" [class]="'btn-1 btn-11'"
                        [disabled]="false" [type]="'button'"></btn>
                </div>
                <div class="col-md-1">
                    <btn [label]="'Back'" (click)="goToBackTab()" [class]="'btn-next btn-11'"
                        [type]="'button'" title="Back Tab"></btn>
                </div>
            </div>-->
        </div>

    </div>
</div>
<ng-template #view let-dataItem let-rowIndex="rowIndex">
    <i class="bi bi-eye-fill" (click)="open(dataItem)"></i>
</ng-template>

<kendo-dialog title="Company Details" *ngIf="opened" (close)="close()" [height]="500" [width]="1000">
    <div class="col-md-12 content-area">
        <div class="row">
            <div class="col-md-4 br-table-data">
                <label for="CompanyName" class="label label-1">Company Name : </label> {{details.CompanyName }}
            </div>
            <div class="col-md-4 br-table-data">
                <label for="CompanyAddress" class="label label-1">Company Address : </label> {{details.CompanyAddress}}
            </div>

            <div class="col-md-4 br-table-data">
                <label for="EmailId" class="label label-1">EmailId : </label> {{details.EmailId }}
            </div>
        </div>
        <div class="row">
            <div class="col-md-4 br-table-data">
                <label for="Phone" class="label label-1">Phone Number : </label> {{details.Phone }}
            </div>

            <div class="col-md-4 br-table-data">
                <label for="CIN" class="label label-1">CIN : </label> {{details.CIN}}
            </div>
            <div class="col-md-4 br-table-data">
                <label for="PAN" class="label label-1">PAN : </label> {{details.PAN}}
            </div>
        </div>
        <div class="row">
            <div class="col-md-4 br-table-data">
                <label for="TAN" class="label label-1">GSTIN : </label> {{details.TAN }}
            </div>
        </div>
    </div>
</kendo-dialog>
<kendo-excelexport [data]="companys.data" [collapsible]="true" fileName="Company.xlsx" #excelexport>
    <kendo-excelexport-column field="SlNo" title="SlNo" [width]="200">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="CompanyName" title="Name" [width]="200">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="CompanyAddress" title="Address" [width]="200">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="EmailId" title="Email" [width]="200">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="Phone" title="Phone" [width]="200">
    </kendo-excelexport-column>
</kendo-excelexport>